import initHeaderScroll from "./modules/header_scroll.js"
import initMobileNav from "./modules/mobile_nav.js"
import initFaq from "./modules/faq.js"
import initScrollReveal from "./modules/scroll_reveal.js"
import initLeadMagnet from "./modules/lead_magnet.js"
import initContact from "./modules/contact.js"

function boot() {
  initHeaderScroll()
  initMobileNav()
  initFaq()
  initScrollReveal()
  initLeadMagnet()
  initContact()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot)
} else {
  boot()
}
